import React from "react";
import "./header.scss";
import { isIE } from "../../utils/deviceDetection";
import envConfig from "../../config/env-config";

const SessionHeader = () => {
  if (isIE()) {
    return (
      <div>
        <div className="banner">
          <div>
            Microsoft Internet Explorer is not a supported browser. For a better
            experience, please use another browser such as Google Chrome or
            Microsoft Edge.
          </div>
        </div>
        <header className="header header--product">
          <div className="header__wrapper">
            <a href={`${envConfig.links.productPageUrl ? `${envConfig.links.productPageUrl}/` : '/'}`}>
              <div className="header__logo" />
            </a>
          </div>
        </header>
      </div>
    );
  }

  return (
    <header className="header header--product">
      <div className="header__wrapper">
          
        <a href={`${envConfig.links.productPageUrl ? `${envConfig.links.productPageUrl}/` : '/'}`}>
          <div className="header__logo" />
        </a>
      </div>
    </header>
  );
};

export default SessionHeader;
